const numberAccept = /[-\d.]+/g
export const parseNumber = (s: string) => (s.match(numberAccept) || []).join("")

export const formatFixedNumberCurrency = (
  value: string | number,
  currency?: string,
  precision: number = 2,
) => {
  const floated = formatFixedPointNumber(value, precision)

  const fp = new Intl.NumberFormat("en-US", {
    style: !!currency ? "currency" : "decimal",
    currency,
    currencyDisplay: "symbol",
  }).formatToParts(+value)

  const c = fp.find((f) => f.type === "currency")?.value || ""

  return !!floated ? `${c} ${floated}` : ""
}

export const formatFloatingPointNumber =
  (maxDigits = 2, minDigits = 0) =>
  (value: string | number) => {
    const parsed = parseNumber(value + "")
    const [head, tail] = parsed.split(".")
    // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
    // must not to convert it to 1.24, it must stay 1.23
    const scaledTail = tail != null ? tail.slice(0, maxDigits) : ""

    const number = Number.parseFloat(`${head}.${scaledTail}`)

    if (Number.isNaN(number)) {
      return ""
    }

    const formatted = number.toLocaleString("en-US", {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
    })
    const [formattedHead] = formatted.split(".")

    return parsed.includes(".") ? `${formattedHead}.${scaledTail}` : formatted
  }

export const formatFixedPointNumber = (
  value: string | number,
  digits: number = 2,
) => {
  const parsed = parseNumber(value + "")
  const [head, tail] = parsed.split(".")

  // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
  // must not to convert it to 1.24, it must stay 1.23
  const scaledTail = tail != null ? tail.slice(0, digits) : ""

  let number = !!head ? Number.parseFloat(`${head}.${scaledTail}`) : ""

  // For fixed format numbers deleting "." must be no-op
  // as imagine u have 123.45 then delete "." and get 12345.00 looks bad in UI
  // so we transform here 12345 into 123.45 instead of 12345.00.
  // The main disadvantage of this, that you need carefully check input value
  // that it always has fractional part
  if (digits > 0 && tail == null && !!number) {
    const _head = head.length < digits + 1 ? head.padEnd(digits + 1, "0") : head
    const paddedHead = _head.padStart(digits + 1 - head.length, "0")
    number = Number.parseFloat(
      `${paddedHead.slice(0, -digits)}.${paddedHead.slice(-digits)}`,
    )
  }

  if (Number.isNaN(number)) {
    return ""
  }

  const formatted = number.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })

  return formatted
}

export const formatFixedPointNumberNoCommas = (
  value: string | number,
  digits: number = 2,
) => {
  const parsed = parseNumber(value + "")
  const [head, tail] = parsed.split(".")

  // Avoid rounding errors at toLocaleString as when user enters 1.239 and maxDigits=2 we
  // must not to convert it to 1.24, it must stay 1.23
  const scaledTail = tail != null ? tail.slice(0, digits) : ""

  let number = !!head ? Number.parseFloat(`${head}.${scaledTail}`) : 0

  // For fixed format numbers deleting "." must be no-op
  // as imagine u have 123.45 then delete "." and get 12345.00 looks bad in UI
  // so we transform here 12345 into 123.45 instead of 12345.00.
  // The main disadvantage of this, that you need carefully check input value
  // that it always has fractional part
  if (digits > 0 && tail == null && !!number) {
    const _head = head.length < digits + 1 ? head.padEnd(digits + 1, "0") : head
    const paddedHead = _head.padStart(digits + 1 - head.length, "0")
    number = Number.parseFloat(
      `${paddedHead.slice(0, -digits)}.${paddedHead.slice(-digits)}`,
    )
  }

  if (Number.isNaN(number)) {
    return ""
  }

  // Format without commas
  const formatted = number.toFixed(digits)

  return formatted
}

// my ass
export function nFormatter(num: number, digits: number): string {
  if (num < 999) {
    return num.toString()
  }
  const an = Math.abs(num)
  const signStr = Math.sign(num) < 0 ? "-" : ""
  // thousands
  if (an < 1e6) {
    const x = (an / 1e3).toFixed(digits)
    return `${signStr}${x}K`
  } else {
    // millions
    const x = (an / 1e6).toFixed(digits)
    return `${signStr}${x}M`
  }
}
